{
  "GENERAL": {
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Ara",
      "EMPTY_STATE": "Kayıt bulunamadı"
    },
    "CLOSE": "Kapat",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "Bu özellik beta aşamasındadır ve geliştirdikçe değişiklik gösterebilir.",
    "ACCEPT": "Kabul et",
    "DISCARD": "Yoksay",
    "PREFERRED": "Preferred"
  },
  "CHOICE_TOGGLE": {
    "YES": "Evet",
    "NO": "Hayır"
  }
}
